<template>
  <div class="home-main-left">
    <div class="home-main-left-content">
      <template v-if="!authorizeObj">
        <div class="header">
          <div class="nav-item"
               :class="currentNav === item.code ? 'active theme-primary-text-color' : ''"
               @click="currentNav = item.code"
               v-for="item in navList"
               :key="item.code">{{item.name}} <div class="underline theme-primary-background-color"></div></div>
        </div>
        <div class="content">
          <home-main-left-login v-if="currentNav === 0"></home-main-left-login>
          <home-main-left-register :current-nav.sync="currentNav" v-if="currentNav === 1"></home-main-left-register>
        </div>
      </template>
      <home-main-left-login-success v-else></home-main-left-login-success>
    </div>
  </div>
</template>

<script>
import HomeMainLeftLogin from './HomeMainLeftLogin'
import HomeMainLeftRegister from './HomeMainLeftRegister'
import HomeMainLeftLoginSuccess from './HomeMainLeftLoginSuccess'
import {mapState} from 'vuex'
export default {
  name: 'HomeMainLeft',
  data () {
    return {
      // 登录：0 注册：1
      currentNav: 0,
      navList: [
        {
          name: '登录',
          code: 0
        },
        {
          name: '注册',
          code: 1
        }
      ]
    }
  },
  computed: {
    ...mapState({
      authorizeObj: state => state.authorization.authorizeObj
    })
  },
  components: {
    HomeMainLeftLogin,
    HomeMainLeftRegister,
    HomeMainLeftLoginSuccess
  },
  created () {
    if (this.$route.query.isRegister) {
      // 默认显示注册
      this.currentNav = 1
    }
  }
}
</script>

<style lang="scss">
.home-main-left {
  background-color: #fff;
  width: 34%;
  box-sizing: border-box;
  padding: 40px 0;
  position: relative;
  &::after {
    content: "";
    width: 1px;
    position: absolute;
    top: 40px;
    bottom: 40px;
    right: 0;
    background-color: #D7D7D7;
  }
  &>.home-main-left-content {
    padding: 0 30px;
    &>.header {
      display: flex;
      border-bottom: 1px solid #b4bbc5;
      &>.nav-item {
        width: 90px;
        height: 35px;
        font-size: 18px;
        text-align: center;
        font-weight: bold;
        color: #A6A5A5;
        cursor: pointer;
        position: relative;
        &>.underline {
          display: none;
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 2px;
        }
        &.active {
          &>.underline {
            display: block;
          }
        }
      }
    }
  }
}
@media (max-width: 1260px) {
  .home-main-left {
    &>.home-main-left-content {
      padding: 0 15px;
    }
  }
}

@media (max-width: 640px) {
  .home-main-left {
    width: 100%;
    margin: 0;
    &::after {
      display: none;
    }
    &>.home-main-left-content {
      border-right: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/homeIndex/HomeMainLeft.vue